const index = [
  {
    name: 'core.menu.general.general-settings',
    path: '/tenant-admin',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'general-settings',
      allowedRoles: ['app-administrator', 'client-administrator', 'system-administrator'],
    },
    children: [
      {
        name: 'core.menu.general.general-settings-home',
        path: 'general-settings',
        component: () =>
          import(
            '@/modules/general-settings/containers/general-settings.container.vue'
          ),
      },
    ],
  },
]

export default index
